import React, { useState, useEffect, useRef } from "react";
import "./NavbarHome.css";
import { Link } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";

function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    let [key, value] = cookie.split("=");
    if (key === name) return decodeURIComponent(value);
  }
  return null;
}

const NavbarHome = (props) => {
  const [isBoxVisible, setIsBoxVisible] = useState(false);
  const buttonRef = useRef(null); // Ref for the button
  const boxRef = useRef(null); // Ref for the hidden box
  const [token, setToken] = useState(getCookie("accessToken"));
  const [isOpen, setIsOpen] = useState(false);



  // Close the box when clicking outside
  useEffect(() => {
    setToken(getCookie("accessToken"))
    const handleClickOutside = (event) => {
      if (
        boxRef.current &&
        !boxRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsBoxVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const GrayUserIcon = () => (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      strokeWidth="1.4"
      xmlns="http://www.w3.org/2000/svg"
      className="block"
    >
      <circle cx="18" cy="18" r="18" fill="#E0E0E0" />
      <ellipse cx="18" cy="15" rx="7" ry="7" fill="#BDBDBD" />
      <ellipse cx="18" cy="27" rx="10" ry="6" fill="#BDBDBD" />
    </svg>
  );

  const toggleBox = () => {
    setIsBoxVisible(!isBoxVisible);
  };

  return (
    <nav className="flex navv items-center justify-between shadow-md bg-beige">
      {/* Left Image */}
      <div className="flex flex-shrink-0 h-auto w-32 sm:w-36 md:w-36 lg:w-40">
        <img
          src={props.user.organization.logo}
          alt="Left Logo"
          className="max-w-40 max-h-10 lg:max-w-44 lg:max-h-10 object-contain cursor-pointer mt-0.5 pt-1"
        />
      </div>


      {/* Right Div */}
      <div className="relative flex-shrink-0 text-right text-xs sm:text-sm md:text-base z-50 w-32 sm:w-40 md:w-44 lg:w-56">
  <button
    className="bg-white py-0.5 px-1.5 flex ml-auto items-center user"
    ref={buttonRef}
    onClick={toggleBox}
  >
    {/* Circular gray user icon */}
    <span className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center mr-2">
    <GrayUserIcon />
    </span>
    <span className="block font-semibold text-sm cursor-pointer text-gray-500 pr-1 hover:text-gray-700">
      {props.user.firstName} {props.user.lastName}
    </span>
    {!isBoxVisible ? (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="4 8 12 16 20 8"></polyline>
    </svg>
    ) : (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="8 4 16 12 8 20"></polyline>
      </svg>
      
    )}
  </button>

  {/* Hidden Box */}
  {isBoxVisible && (
    <div
      ref={boxRef}
      className="absolute -right-3 mt-2 bg-white shadow-md rounded-lg w-40 md:w-44 hover:bg-gray-100 p-2"
      id="signoutbox"
    >
      {/* Only show options, no name or welcome */}
      {token && (
        <Link
          className="block w-full px-2 py-1.5 my-1 text-left text-xs sm:text-sm md:text-base flex items-center rounded-lg hover:bg-gray-100 text-gray-700 hover:text-gray-700 hover:underline hover:decoration-gray-500"
          to="../admin"
        >
          <img src="/images/Admin.png" className="w-5 h-5" />
          <span className="ml-1">Administration</span>
        </Link>
      )}

      {props.diffOrg.length > 0 && (
        <div className="relative inline-block w-full">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="block w-full px-2 py-1.5 my-1 text-left text-xs sm:text-sm md:text-base flex items-center rounded-lg hover:bg-gray-100 text-gray-700 hover:text-gray-700 hover:underline hover:decoration-gray-500"
          >
            <img src="/images/changeOrg.png" className="w-5 h-5" />
            <span className="ml-1">Switch Org</span>
            <FaChevronDown
              className={`ml-auto font-thin w-4 h-4 transition-transform ${isOpen ? "rotate-180" : "rotate-0"}`}
            />
          </button>
          {isOpen && (
            <ul className="absolute left-0 w-full mt-2 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
              {props.diffOrg.map((org, index) => (
                <li key={index}>
                  <button
                    className="block w-full py-2 px-4 text-sm text-gray-700 hover:bg-gray-50 hover:text-gray-900 rounded-lg"
                    onClick={() => { setIsOpen(false); props.changeUser(org); }}
                  >
                    {org}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}

      <button
        onClick={() => { sessionStorage.removeItem('accessToken'); props.logout(); }}
        className="block w-full px-2 py-1.5 my-1 text-left text-xs sm:text-sm md:text-base flex items-center rounded-lg hover:bg-gray-100 text-gray-700 hover:underline hover:decoration-gray-500"
      >
        <img src="/images/SignOut.png" className="w-5 h-4" />
        <span className="ml-1">Sign Out</span>
      </button>
    </div>
  )}
</div>

    </nav>
  );
};

export default NavbarHome;
